import React, { useRef, useState } from 'react';
import { Play, Pause, Volume2 } from 'lucide-react';
import { homeVideo } from '../mock';

export default function VideoSection() {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [started, setStarted] = useState(false);

  const play = () => {
    if (!ref.current) return;
    ref.current.muted = false;
    ref.current.play().catch(() => {
      // Autoplay with sound may be blocked — try muted play as fallback and let user unmute via controls
      if (ref.current) {
        ref.current.muted = true;
        ref.current.play();
      }
    });
    setStarted(true);
  };

  return (
    <section className="section bg-white">
      <div className="container-x grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="eyebrow">See it in action</div>
          <h2 className="section-title mt-3">
            How We <span className="grad-text">Grow Your Sales</span>
          </h2>
          <p className="section-sub mt-4">
            {homeVideo.sub}
          </p>
          <ul className="mt-6 space-y-2 text-sm text-[color:var(--ink)]">
            {[
              'Dedicated team working on your brand daily',
              'Data-backed listing & catalog optimisation',
              'Ad campaigns that drive real orders',
              'Social & website support to compound growth',
            ].map((t) => (
              <li key={t} className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 mt-2 rounded-full bg-[color:var(--brand-green)]" />
                {t}
              </li>
            ))}
          </ul>
          <div className="mt-6 inline-flex items-center gap-2 bg-[color:var(--brand-green-light)] text-[color:var(--brand-green-dark)] px-4 py-2 rounded-full text-xs font-semibold">
            <Volume2 size={14} /> Click play to watch with sound
          </div>
        </div>

        {/* Video container — sized so the entire video is visible without cropping.
            Uses object-contain and a max height so portrait or landscape both look good. */}
        <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-white bg-neutral-900 mx-auto w-full max-w-[420px]">
          <video
            ref={ref}
            src={homeVideo.src}
            poster={homeVideo.poster}
            playsInline
            preload="auto"
            controls={started}
            className="block w-full h-auto max-h-[640px] object-contain bg-neutral-900"
            onPlay={() => setPlaying(true)}
            onPause={() => setPlaying(false)}
            onEnded={() => { setPlaying(false); setStarted(false); }}
          />

          {!started && (
            <button
              onClick={play}
              className="absolute inset-0 flex flex-col items-center justify-center bg-black/40 hover:bg-black/50 transition"
              aria-label="Play video"
            >
              <div className="w-20 h-20 rounded-full bg-white shadow-2xl flex items-center justify-center text-[color:var(--brand-green)] hover:scale-110 transition-transform">
                <Play size={32} className="ml-1.5" fill="currentColor" />
              </div>
              <div className="mt-4 px-4 py-1.5 rounded-full bg-white/95 text-[color:var(--ink)] text-xs font-semibold flex items-center gap-1.5 shadow-lg">
                <Volume2 size={12} /> Play with sound
              </div>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
